import { render, staticRenderFns } from "./PaymentRequest.vue?vue&type=template&id=0d58c2e2"
import script from "./PaymentRequest.vue?vue&type=script&lang=ts"
export * from "./PaymentRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports